"use client";
import {
  MenubarContextProvider,
  MenubarScopedContextProvider,
  useMenubarContext,
  useMenubarProviderContext,
  useMenubarScopedContext
} from "./VBF5EZBB.js";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./3D6OCOHF.js";
import {
  HovercardContextProvider,
  HovercardScopedContextProvider
} from "./TWDHCE7Y.js";
import {
  createStoreContext
} from "./5M6RSQEC.js";

// src/menu/menu-context.ts
import { createContext } from "react";
var menu = createStoreContext(
  [CompositeContextProvider, HovercardContextProvider],
  [CompositeScopedContextProvider, HovercardScopedContextProvider]
);
var useMenuContext = menu.useContext;
var useMenuScopedContext = menu.useScopedContext;
var useMenuProviderContext = menu.useProviderContext;
var MenuContextProvider = menu.ContextProvider;
var MenuScopedContextProvider = menu.ScopedContextProvider;
var useMenuBarContext = useMenubarContext;
var useMenuBarScopedContext = useMenubarScopedContext;
var useMenuBarProviderContext = useMenubarProviderContext;
var MenuBarContextProvider = MenubarContextProvider;
var MenuBarScopedContextProvider = MenubarScopedContextProvider;
var MenuItemCheckedContext = createContext(
  void 0
);

export {
  useMenuContext,
  useMenuScopedContext,
  useMenuProviderContext,
  MenuContextProvider,
  MenuScopedContextProvider,
  useMenuBarContext,
  useMenuBarScopedContext,
  useMenuBarProviderContext,
  MenuBarContextProvider,
  MenuBarScopedContextProvider,
  MenuItemCheckedContext
};
